export default __webpack_public_path__ + "static/media/injection.80198079.png";